import contactImg from "../assets/connect_with_us.png";
import "../Css/ContactUs.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaTimes,
  FaCheckCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaSpinner,
  FaWhatsapp
} from "react-icons/fa";
import { useState, useEffect } from "react";

const ContactUs = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("success");
  const [isLoading, setIsLoading] = useState(false);

  // Load registered phone numbers from localStorage on component mount
  const getRegisteredPhones = () => {
    const stored = localStorage.getItem("registeredPhones");
    return stored ? JSON.parse(stored) : [];
  };

  // Save registered phone numbers to localStorage
  const saveRegisteredPhone = (phoneNumber) => {
    const registeredPhones = getRegisteredPhones();
    if (!registeredPhones.includes(phoneNumber)) {
      registeredPhones.push(phoneNumber);
      localStorage.setItem("registeredPhones", JSON.stringify(registeredPhones));
    }
  };

  // Check if phone number is already registered
  const isPhoneRegistered = (phoneNumber) => {
    const registeredPhones = getRegisteredPhones();
    return registeredPhones.includes(phoneNumber);
  };

  const handleWhatsAppSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const fullName = form.fullName.value.trim();
    const phone = form.phone.value.trim();
    const studentClass = form.studentClass.value.trim();

    // Validate phone number
    if (!/^[0-9]{10}$/.test(phone)) {
      showPopupMessage("Please enter a valid 10-digit mobile number", "error");
      return;
    }

    // Check if phone number is already registered
    if (isPhoneRegistered(phone)) {
      showPopupMessage("This mobile number has already been registered! We will contact you shortly.", "warning");
      return;
    }

    setIsLoading(true);

    // Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }


  if (window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18010136260/22IhCKG2t5ccEMS984tD'
    });
  }


    try {
      const formData = new FormData();
      formData.append("fullName", fullName);
      formData.append("phone", phone);
      formData.append("studentClass", studentClass);

      await fetch("https://script.google.com/macros/s/AKfycbz7LDGTDkCcTCh4mpNHtMKIxNbipxf2Q-lO7gJN5lRTbMoHhdiPJYcWW3_OytOt8S9QTA/exec", {
        method: "POST",
        mode: "no-cors",
        body: formData
      });

      // Save the registered phone number
      saveRegisteredPhone(phone);
      
      // Show success popup
      showPopupMessage("Thank you for reaching out! We will connect with you shortly.", "success");
      form.reset();

    } catch (error) {
      console.error("Error submitting form:", error);
      showPopupMessage("Something went wrong. Please try again later.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const showPopupMessage = (message, type = "success") => {
    setPopupMessage(message);
    setPopupType(type);
    setShowPopup(true);
    
    // Auto hide after 4 seconds
    setTimeout(() => {
      setShowPopup(false);
    }, 4000);
  };

  // Get popup icon based on type
  const getPopupIcon = () => {
    switch(popupType) {
      case "success":
        return <FaCheckCircle className="popup-icon success-icon" />;
      case "warning":
        return <FaExclamationTriangle className="popup-icon warning-icon" />;
      case "error":
        return <FaInfoCircle className="popup-icon error-icon" />;
      default:
        return <FaCheckCircle className="popup-icon success-icon" />;
    }
  };

  return (
    <div className="contact-page">


{/* BEAUTIFUL POPUP MODAL */}
{showPopup && (
  <div className="popup-overlay" onClick={() => setShowPopup(false)}>
    <div className={`popup-container ${popupType}`} onClick={(e) => e.stopPropagation()}>
      <button className="popup-close-btn" onClick={() => setShowPopup(false)}>
        <FaTimes />
      </button>
      
      <div className="popup-icon-wrapper">
        <div className="popup-icon-circle">
          {popupType === "success" && <FaCheckCircle className="popup-icon success-icon" />}
          {popupType === "warning" && <FaInfoCircle className="popup-icon warning-icon" />}
          {popupType === "error" && <FaExclamationTriangle className="popup-icon error-icon" />}
        </div>
      </div>
      
      <div className="popup-content-wrapper">
        <h3 className="popup-title">
          {popupType === "success" && "Registration Successful!"}
          {popupType === "warning" && "Already in Our System! 📞"}
          {popupType === "error" && "Submission Failed!"}
        </h3>
        
        <div className="popup-message-box">
          <p className="popup-message-text">{popupMessage}</p>
          
          {popupType === "success" && (
            <div className="success-details">
              <p className="success-note">
                ✨ Our team will reach out to you within 24 hours
              </p>
              <div className="next-steps">
                <span>📚 Prepare for your journey</span>
                <span>💡 Stay tuned for updates</span>
              </div>
            </div>
          )}
          
          {popupType === "warning" && (
            <div className="warning-details">
              <div className="warning-contact-card">
                <p className="warning-message">
                  Don't worry! Our team is already processing your inquiry.
                </p>
                <div className="warning-contact-item">
                  <FaPhoneAlt className="warning-icon-small" />
                  <span>Need immediate help? Call: <a href="tel:+918849189845">+91 88491 89845</a></span>
                </div>
                <div className="warning-contact-item">
                  <FaWhatsapp className="warning-icon-small" />
                  <span>Chat on WhatsApp: <a href="https://wa.me/918849189845">Click here</a></span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <button className="popup-action-btn" onClick={() => setShowPopup(false)}>
        {popupType === "success" ? "Continue" : "Got It"}
      </button>
      
      <div className="popup-progress-bar">
        <div className="popup-progress-fill"></div>
      </div>
    </div>
  </div>
)}



      {/* CONTACT SECTION */}
      <section className="contact-section">
        <div className="contact-container">

          {/* LEFT */}
          <div className="contact-left">
            <img src={contactImg} alt="Contact IITians Chinmay Academy" />
            <p className="contact-slogan">
              Shaping <a style= {{color:"blue"}}>IIT-JEE</a> Aspirants with Expert Guidance
            </p>
          </div>

          {/* FORM */}
          <div className="contact-form-card">
            <form onSubmit={handleWhatsAppSubmit}>

              {/* FULL NAME */}
              <div className="form-field">
                <label>Full Name *</label>
                <input
                  name="fullName"
                  placeholder="Enter full name"
                  required
                  disabled={isLoading}
                />
              </div>

              {/* PHONE */}
              <div className="form-field">
                <label>Mobile Number *</label>
                <input
                  name="phone"
                  placeholder="Enter 10-digit mobile number"
                  required
                  disabled={isLoading}
                />
              </div>

              {/* CLASS */}
              <div className="form-field">
                <label>Class *</label>
                <select name="studentClass" required disabled={isLoading}>
                  <option value="">Select Class</option>
                  {[...Array(7)].map((_, i) => {
                    const cls = i + 6;
                    return (
                      <option key={cls} value={cls}>
                        Class {cls}
                      </option>
                    );
                  })}
                </select>
              </div>

              <button type="submit" className="whatsapp-submit" disabled={isLoading}>
                {isLoading ? <><FaSpinner className="spinner" /> Submitting...</> : "Submit"}
              </button>

            </form>
          </div>

        </div>
      </section>

      {/* CONTACT INFO */}
      <section className="contact-info-section">
        <div className="contact-info-container">
          <h2 className="contact-info-title">Get In Touch</h2>

          <div className="contact-cards">

            {/* CALL */}
            <div className="contact-card">
              <div className="contact-icon">
                <FaPhoneAlt />
              </div>
              <div className="contact-text">
                <h4>Call us</h4>
                <p className="phone-number">
                  <a href="tel:+918849189845">+91 8849189845</a>
                </p>
                <p className="phone-number">
                  <a href="tel:+917227802444">+91 7227802444</a>
                </p>
              </div>
            </div>

            {/* EMAIL */}
            <div className="contact-card">
              <div className="contact-icon">
                <FaEnvelope />
              </div>
              <div className="contact-text">
                <h4>Email us</h4>
                <p>asitgodbole@gmail.com</p>
              </div>
            </div>

            {/* ADDRESS */}
            <a
              href="https://maps.app.goo.gl/QCX8LamQiFbAer9J8"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card"
            >
              <div className="contact-icon">
                <FaMapMarkerAlt />
              </div>
              <div className="contact-text">
                <h4>Visit us</h4>
                <p>
                  SF-9 & 10, Shivalay 2, Vasna Rd, Tandalja, Vadodara – 390007
                </p>
              </div>
            </a>

          </div>

          {/* MAP */}
          <section className="map-section">
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.5645653778297!2d73.1512974!3d22.294478500000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc627466c6f6f%3A0x14618268b3ad7ac0!2sIITians%20Chinmay%20Academy%20%E2%80%93%20IIT%20JEE%20Coaching%20in%20Vadodara!5e0!3m2!1sen!2sin!4v1772173229214!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="IITians Chinmay Academy – IIT JEE Coaching in Vadodara"
              ></iframe>
            </div>
          </section>

        </div>
      </section>

    </div>
  );
};

export default ContactUs;